import { Component, OnInit } from '@angular/core';
import firebase from 'firebase/compat';
import initializeApp = firebase.initializeApp;

@Component({
  selector: 'prism-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {
  constructor() {

  }

  ngOnInit() {

  }
}
